/**
 * Collection PLP — filters via Section Rendering API + infinite scroll (collection & search).
 */
(function () {
  'use strict';

  var page = document.getElementById('CollectionPage');
  var infiniteControllers = [];
  var filterModal = { open: false, mode: 'filters', lastFocus: null };
  var clientSearchActive = false;
  var collectionProductsCache = null;
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var DEFAULT_COLLECTION_SORT = 'price-ascending';

  initCollectionFilters();
  initAllInfiniteScroll();
  initCollectionDescription();

  document.addEventListener('mootlu:filters-applied', function () {
    destroyInfiniteScroll();
    initAllInfiniteScroll();
  });

  function isMobileFilters() {
    return MOBILE_MQ.matches;
  }

  function getFiltersShell() {
    return document.querySelector('[data-collection-filters-shell]');
  }

  function getFiltersShellInner() {
    return document.querySelector('[data-filters-shell-inner]');
  }

  function getFilterPortal() {
    return document.querySelector('[data-filter-modal-portal]');
  }

  function getFilterModal() {
    return document.querySelector('[data-filter-modal]');
  }

  function getSortPortal() {
    return document.querySelector('[data-sort-modal-portal]');
  }

  function getSortForm() {
    return document.querySelector('[data-sort-form]');
  }

  function getSortFormHost() {
    return document.querySelector('[data-sort-form-host]');
  }

  function moveFiltersToModal(mode) {
    var inner = getFiltersShellInner();
    var filterPortal = getFilterPortal();
    var sortPortal = getSortPortal();
    var sortForm = getSortForm();
    var sortHost = getSortFormHost();
    var shell = getFiltersShell();

    if (mode === 'sort') {
      if (inner && shell && inner.parentElement !== shell) {
        shell.appendChild(inner);
      }
      if (sortPortal && sortForm) {
        sortPortal.appendChild(sortForm);
        sortPortal.removeAttribute('hidden');
        var disclosure = sortForm.querySelector('.collection-sort-disclosure');
        if (disclosure) disclosure.setAttribute('open', '');
      }
      if (filterPortal) filterPortal.hidden = true;
    } else {
      if (inner && filterPortal) {
        filterPortal.appendChild(inner);
        filterPortal.hidden = false;
      }
      if (sortHost && sortForm) {
        sortHost.appendChild(sortForm);
        var sortDisclosure = sortForm.querySelector('.collection-sort-disclosure');
        if (sortDisclosure) sortDisclosure.removeAttribute('open');
      }
      if (sortPortal) sortPortal.setAttribute('hidden', '');
    }
  }

  function setModalUi(mode) {
    var modal = getFilterModal();
    if (!modal) return;
    modal.classList.remove('is-mode-filters', 'is-mode-sort');
    modal.classList.add(mode === 'sort' ? 'is-mode-sort' : 'is-mode-filters');
    var titleEl = modal.querySelector('[data-filter-modal-title]');
    if (titleEl) {
      titleEl.textContent =
        mode === 'sort'
          ? modal.getAttribute('data-title-sort') || 'Sırala'
          : modal.getAttribute('data-title-filters') || 'Filtreler';
    }
  }

  function setModalMode(mode) {
    if (!filterModal.open) return;
    filterModal.mode = mode;
    restoreFiltersToShell();
    moveFiltersToModal(mode);
    setModalUi(mode);
  }

  function restoreFiltersToShell() {
    var shell = getFiltersShell();
    var inner = getFiltersShellInner();
    if (!shell || !inner) return;
    shell.appendChild(inner);
    var sortHost = getSortFormHost();
    var sortForm = getSortForm();
    if (sortHost && sortForm) {
      sortHost.appendChild(sortForm);
      var restoredDisclosure = sortForm.querySelector('.collection-sort-disclosure');
      if (restoredDisclosure) restoredDisclosure.removeAttribute('open');
    }
    var filterPortal = getFilterPortal();
    var sortPortal = getSortPortal();
    if (filterPortal) filterPortal.hidden = false;
    if (sortPortal) sortPortal.setAttribute('hidden', '');
  }

  function openFilterModal(options) {
    options = options || {};
    var mode = options.mode || 'filters';
    if (!isMobileFilters()) return;
    var modal = getFilterModal();
    if (!modal) return;
    filterModal.lastFocus = document.activeElement;
    filterModal.open = true;
    filterModal.mode = mode;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    restoreFiltersToShell();
    moveFiltersToModal(mode);
    setModalUi(mode);
    var closeBtn = modal.querySelector('.collection-filters-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeFilterModal() {
    if (!filterModal.open) return;
    var modal = getFilterModal();
    filterModal.open = false;
    filterModal.mode = 'filters';
    if (modal) {
      modal.hidden = true;
      modal.classList.remove('is-mode-filters', 'is-mode-sort');
    }
    document.body.style.overflow = '';
    restoreFiltersToShell();
    if (filterModal.lastFocus && typeof filterModal.lastFocus.focus === 'function') {
      filterModal.lastFocus.focus();
    }
    filterModal.lastFocus = null;
  }

  function initAllInfiniteScroll() {
    var collectionRoot = document.getElementById('CollectionPage');
    if (collectionRoot) initInfiniteScroll(collectionRoot);
    var searchRoot = document.getElementById('SearchResults');
    if (searchRoot) initInfiniteScroll(searchRoot);
  }

  function destroyInfiniteScroll() {
    infiniteControllers.forEach(function (ctrl) {
      if (ctrl.observer) ctrl.observer.disconnect();
    });
    infiniteControllers = [];
  }

  function initInfiniteScroll(root) {
    var grid = root.querySelector('[data-infinite-grid]');
    var sentinel = root.querySelector('[data-infinite-sentinel]');
    if (!grid || !sentinel) return;

    var ctrl = {
      root: root,
      grid: grid,
      sentinel: sentinel,
      status: root.querySelector('[data-infinite-status]'),
      loadingEl: root.querySelector('[data-infinite-loading]'),
      endEl: root.querySelector('[data-infinite-end]'),
      loading: false,
      observer: null,
      mode: root.id === 'SearchResults' ? 'search' : 'collection',
      sectionId: getSectionId(),
    };

    refreshInfiniteUi(ctrl);

    if (!grid.dataset.infiniteNext) {
      return;
    }

    sentinel.hidden = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage(ctrl);
        });
      },
      { rootMargin: '400px' }
    );
    observer.observe(sentinel);
    ctrl.observer = observer;
    infiniteControllers.push(ctrl);
  }

  function refreshInfiniteUi(ctrl) {
    var grid = ctrl.grid;
    var hasNext = !!grid.dataset.infiniteNext;
    var currentPage = parseInt(grid.dataset.infinitePage || '1', 10);
    var totalPages = parseInt(grid.dataset.infinitePages || '1', 10);

    if (ctrl.loadingEl) ctrl.loadingEl.hidden = true;
    if (ctrl.endEl) ctrl.endEl.hidden = true;

    if (!hasNext) {
      ctrl.sentinel.hidden = true;
      if (totalPages > 1 && currentPage >= totalPages && ctrl.status && ctrl.endEl) {
        ctrl.status.hidden = false;
        ctrl.endEl.hidden = false;
      } else if (ctrl.status) {
        ctrl.status.hidden = true;
      }
      return;
    }

    ctrl.sentinel.hidden = false;
    if (ctrl.status) ctrl.status.hidden = true;
  }

  function loadNextPage(ctrl) {
    if (ctrl.loading) return;
    var nextUrl = ctrl.grid.dataset.infiniteNext;
    if (!nextUrl) return;

    ctrl.loading = true;
    if (ctrl.status) ctrl.status.hidden = false;
    if (ctrl.loadingEl) ctrl.loadingEl.hidden = false;
    if (ctrl.endEl) ctrl.endEl.hidden = true;

    var fetchUrl = nextUrl;
    if (ctrl.mode === 'collection') {
      var sep = nextUrl.indexOf('?') >= 0 ? '&' : '?';
      fetchUrl =
        nextUrl +
        sep +
        'section_id=' +
        encodeURIComponent(ctrl.sectionId) +
        '&_t=' +
        Date.now();
    }

    fetch(fetchUrl, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'fetch' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('infinite fetch failed');
        return r.text();
      })
      .then(function (html) {
        var newGrid = extractInfiniteGrid(html, ctrl);
        if (!newGrid) throw new Error('no grid in response');
        appendGridItems(newGrid, ctrl.grid);
        syncInfiniteMeta(newGrid, ctrl.grid);
        refreshInfiniteUi(ctrl);
      })
      .catch(function () {
        /* retry on next scroll intersection */
      })
      .finally(function () {
        ctrl.loading = false;
        if (ctrl.loadingEl) ctrl.loadingEl.hidden = true;
      });
  }

  function extractInfiniteGrid(html, ctrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (ctrl.mode === 'search') {
      var searchRoot = doc.getElementById('SearchResults');
      return searchRoot ? searchRoot.querySelector('[data-infinite-grid]') : null;
    }

    var fromSection = doc.getElementById('shopify-section-' + ctrl.sectionId);
    if (fromSection) return fromSection.querySelector('[data-infinite-grid]');

    var fromPage = doc.getElementById('CollectionPage');
    if (fromPage) return fromPage.querySelector('[data-infinite-grid]');

    return doc.querySelector('[data-infinite-grid]');
  }

  function syncInfiniteMeta(fromGrid, toGrid) {
    toGrid.dataset.infinitePage = fromGrid.dataset.infinitePage || '';
    toGrid.dataset.infinitePages = fromGrid.dataset.infinitePages || '';
    if (fromGrid.dataset.infiniteNext) {
      toGrid.dataset.infiniteNext = fromGrid.dataset.infiniteNext;
    } else {
      delete toGrid.dataset.infiniteNext;
    }
  }

  function appendGridItems(fromGrid, toGrid) {
    Array.from(fromGrid.children).forEach(function (child) {
      if (child.classList && child.classList.contains('collection-products-grid__empty')) return;
      toGrid.appendChild(child);
    });
  }

  function getGridProductHandles() {
    var grid = document.querySelector('[data-infinite-grid]');
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('.prod-card[data-product-handle]')).map(function (card) {
      return card.getAttribute('data-product-handle');
    });
  }

  function clearClientSearchFilter() {
    clientSearchActive = false;
    var grid = document.querySelector('[data-infinite-grid]');
    if (!grid) return;
    grid.querySelectorAll('.prod-card.is-search-hidden').forEach(function (card) {
      card.classList.remove('is-search-hidden');
    });
    var empty = grid.querySelector('.collection-products-grid__empty--client-search');
    if (empty) empty.remove();
  }

  function applyClientSearchFilter(handles) {
    var grid = document.querySelector('[data-infinite-grid]');
    if (!grid) return;
    var set = {};
    handles.forEach(function (h) {
      set[h] = true;
    });
    var visible = 0;
    grid.querySelectorAll('.prod-card[data-product-handle]').forEach(function (card) {
      var h = card.getAttribute('data-product-handle');
      var show = !!set[h];
      card.classList.toggle('is-search-hidden', !show);
      if (show) visible += 1;
    });
    var empty = grid.querySelector('.collection-products-grid__empty--client-search');
    if (visible === 0) {
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'collection-products-grid__empty collection-products-grid__empty--client-search';
        var msg =
          (window.MOOTLU_DATA && window.MOOTLU_DATA.t && window.MOOTLU_DATA.t.search_no_results_in_category) ||
          'Bu kategoride eşleşen ürün bulunamadı.';
        empty.textContent = msg;
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
    clientSearchActive = true;
  }

  function normalizeSearchText(value) {
    var s = String(value || '')
      .trim()
      .toLowerCase();
    try {
      if (typeof s.normalize === 'function') s = s.normalize('NFD').replace(/\p{M}/gu, '');
    } catch (err) {
      /* ignore */
    }
    return s
      .replace(/ı/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/\s+/g, ' ');
  }

  function parseProductHandle(product) {
    if (product && product.handle) return product.handle;
    var url = (product && product.url) || '';
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function productMatchesTerm(product, term) {
    var q = normalizeSearchText(term);
    if (!q || q.length < 2) return false;
    var parts = [
      product.title,
      product.vendor,
      product.product_type,
      (product.handle || '').replace(/-/g, ' '),
    ];
    if (product.tags && product.tags.length) {
      parts = parts.concat(product.tags);
    }
    return normalizeSearchText(parts.filter(Boolean).join(' ')).indexOf(q) >= 0;
  }

  function getCollectionProductsCache() {
    if (collectionProductsCache) return Promise.resolve(collectionProductsCache);
    var handle = page && page.dataset.collectionHandle;
    if (!handle) return Promise.resolve([]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('products.json failed');
        return r.json();
      })
      .then(function (data) {
        collectionProductsCache = data.products || [];
        return collectionProductsCache;
      })
      .catch(function () {
        collectionProductsCache = [];
        return collectionProductsCache;
      });
  }

  function normalizePredictiveSearchBase(base) {
    var trimmed = String(base || '').replace(/\/$/, '');
    if (!trimmed) return '/search/suggest.json';
    if (trimmed.slice(-5) === '.json') return trimmed;
    return trimmed + '.json';
  }

  function runCollectionSearch(term) {
    var DATA = window.MOOTLU_DATA || {};
    var base = normalizePredictiveSearchBase(
      (DATA.routes && DATA.routes.predictive_search_url) || '/search/suggest.json'
    );
    var url =
      base +
      (base.indexOf('?') >= 0 ? '&' : '?') +
      'q=' +
      encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=50&resources[limit_scope]=each';

    return Promise.all([
      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
        return r.ok ? r.json() : { resources: { results: { products: [] } } };
      }),
      getCollectionProductsCache(),
    ]).then(function (results) {
      var predictiveProducts =
        (results[0].resources && results[0].resources.results && results[0].resources.results.products) || [];
      var collectionProducts = results[1];
      var collectionSet = {};
      collectionProducts.forEach(function (p) {
        var h = parseProductHandle(p);
        if (h) collectionSet[h] = true;
      });

      var matchedSet = {};
      collectionProducts.forEach(function (p) {
        var h = parseProductHandle(p);
        if (h && productMatchesTerm(p, term)) matchedSet[h] = true;
      });

      predictiveProducts.forEach(function (p) {
        var h = parseProductHandle(p);
        if (h && collectionSet[h]) matchedSet[h] = true;
      });

      applyClientSearchFilter(Object.keys(matchedSet));
    });
  }

  function initCollectionFilters() {
    page = document.getElementById('CollectionPage');
    if (!page) return;

    var filterForm = document.getElementById('CollectionFiltersForm');
    var sortForm = document.querySelector('[data-sort-form]');
    var SORT_KEY = 'mootlu:sort:' + (page.dataset.collectionHandle || 'default');
    var applying = false;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-modal-open]')) {
        e.preventDefault();
        openFilterModal({ mode: 'filters' });
        return;
      }

      if (e.target.closest('[data-sort-modal-open]')) {
        e.preventDefault();
        openFilterModal({ mode: 'sort' });
        return;
      }

      if (e.target.closest('[data-modal-sort-open]')) {
        e.preventDefault();
        setModalMode('sort');
        return;
      }

      if (e.target.closest('[data-filter-modal-close]')) {
        e.preventDefault();
        closeFilterModal();
        return;
      }

      if (e.target.closest('[data-filter-modal-apply]')) {
        e.preventDefault();
        applyFilters();
        closeFilterModal();
        return;
      }

      var sw = e.target.closest('[data-card-img-src]');
      if (!sw) return;
      e.preventDefault();
      var card = sw.closest('.prod-card');
      if (!card) return;
      var img = card.querySelector('[data-card-img]');
      if (img) {
        img.setAttribute('src', sw.getAttribute('data-card-img-src'));
        var srcset = sw.getAttribute('data-card-img-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
      }
      card.querySelectorAll('.prod-card__swatch').forEach(function (s) {
        s.classList.remove('is-active');
      });
      sw.classList.add('is-active');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterModal.open) {
        e.preventDefault();
        closeFilterModal();
      }
    });

    // Default sort is owned by the collection's admin "default sort order" setting,
    // so the server already renders the grid in the right order and the sort control
    // reflects the server-rendered value. No client-side redirect or AJAX re-sort on
    // landing (both previously caused a wasteful reload / "old order then re-sort" flash).

    if (filterForm) {
      bindFilterForm(filterForm);
    }

    if (sortForm) {
      bindSortForm(sortForm, SORT_KEY, applyFilters);
    }

    var searchInput = document.querySelector('[data-collection-search]');
    if (searchInput) {
      bindCollectionSearch(searchInput, applyCollectionSearch);
    }

    window.addEventListener('popstate', function () {
      var pageUrl = window.location.href;
      var sectionId = getSectionId();
      var fetchUrl =
        pageUrl +
        (pageUrl.indexOf('?') >= 0 ? '&' : '?') +
        'section_id=' +
        encodeURIComponent(sectionId) +
        '&_t=' +
        Date.now();
      fetch(fetchUrl, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'fetch' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch failed');
          return r.text();
        })
        .then(function (html) {
          if (!mergeCollectionHtml(html, false)) window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        });
    });

    function applyCollectionSearch() {
      var searchEl = document.querySelector('[data-collection-search]');
      var term = searchEl ? searchEl.value.trim() : '';

      if (!term) {
        clearClientSearchFilter();
        applyFilters();
        return;
      }

      if (term.length < 2) {
        clearClientSearchFilter();
        var builtShort = buildFilterUrl();
        window.history.pushState({ mootluFilter: true }, '', builtShort.url);
        return;
      }

      var built = buildFilterUrl();
      window.history.pushState({ mootluFilter: true }, '', built.url);
      runCollectionSearch(term);
    }

    function applyFilters(done) {
      if (applying) return;
      applying = true;

      var built = buildFilterUrl();
      var newUrl = built.url;
      var qs = built.qs;

      window.history.pushState({ mootluFilter: true }, '', newUrl);

      var grid = document.querySelector('[data-collection-grid]');
      if (grid) grid.setAttribute('aria-busy', 'true');

      var sectionId = getSectionId();
      var fetchUrl =
        newUrl +
        (qs ? '&' : '?') +
        'section_id=' +
        encodeURIComponent(sectionId) +
        '&_t=' +
        Date.now();

      fetch(fetchUrl, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'fetch' },
        credentials: 'same-origin',
      })
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch failed');
          return r.text();
        })
        .then(function (html) {
          if (mergeCollectionHtml(html, false)) {
            applying = false;
            return;
          }
          return fetch(newUrl, {
            headers: { Accept: 'text/html', 'X-Requested-With': 'fetch' },
            credentials: 'same-origin',
          }).then(function (r) {
            if (!r.ok) throw new Error('page fetch failed');
            return r.text();
          });
        })
        .then(function (html) {
          if (!html) return;
          if (!mergeCollectionHtml(html, true)) {
            throw new Error('no collection markup');
          }
        })
        .catch(function () {
          window.location.assign(newUrl);
        })
        .finally(function () {
          applying = false;
          var activeGrid = document.querySelector('[data-collection-grid]');
          if (activeGrid) activeGrid.setAttribute('aria-busy', 'false');
          if (typeof done === 'function') done();
        });
    }

    function bindCollectionSearch(input, onApply) {
      input.addEventListener(
        'input',
        debounce(function () {
          onApply();
        }, 400)
      );
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          onApply();
        }
      });
    }

    function buildFilterUrl() {
      var fd = filterForm ? new FormData(filterForm) : new FormData();
      var sortVal = (document.getElementById('SortBy') || {}).value || DEFAULT_COLLECTION_SORT;
      fd.set('sort_by', sortVal);

      var searchEl = document.querySelector('[data-collection-search]');
      if (searchEl) {
        var q = searchEl.value.trim();
        if (q) fd.set('q', q);
      }

      var params = new URLSearchParams();
      fd.forEach(function (v, k) {
        if (v !== '') params.append(k, v);
      });
      var qs = params.toString();
      return {
        qs: qs,
        url: window.location.pathname + (qs ? '?' + qs : ''),
      };
    }

    function syncSearchFromUrl() {
      var searchEl = document.querySelector('[data-collection-search]');
      if (!searchEl) return;
      var q = new URL(window.location.href).searchParams.get('q') || '';
      searchEl.value = q;
    }

    function syncSortRadios(form) {
      if (!form) return;
      var select = form.querySelector('#SortBy');
      if (!select) return;
      var val = select.value;
      form.querySelectorAll('[data-sort-radio]').forEach(function (radio) {
        radio.checked = radio.value === val;
        var label = radio.closest('.collection-sort__option');
        if (label) label.classList.toggle('is-selected', radio.checked);
      });
      syncSortCurrentLabel(form);
    }

    function syncSortCurrentLabel(form) {
      var select = form.querySelector('#SortBy');
      var labelEl = form.querySelector('[data-sort-current-label]');
      if (!select || !labelEl) return;
      var opt = select.options[select.selectedIndex];
      if (opt) labelEl.textContent = opt.textContent;
    }

    function closeSortDisclosure(form) {
      if (filterModal.open && filterModal.mode === 'sort') return;
      var disclosure = form && form.querySelector('.collection-sort-disclosure');
      if (disclosure) disclosure.removeAttribute('open');
    }

    function onSortApply(form, sortKey, onApply) {
      var select = form.querySelector('#SortBy');
      return function () {
        syncSortRadios(form);
        closeSortDisclosure(form);
        try {
          sessionStorage.setItem(sortKey, select.value);
        } catch (err) {
          /* ignore */
        }
        onApply();
        if (filterModal.open && filterModal.mode === 'sort') {
          closeFilterModal();
        }
      };
    }

    function bindSortForm(form, sortKey, onApply) {
      var select = form.querySelector('#SortBy');
      if (!select) return;

      syncSortRadios(form);
      var handleSortApply = onSortApply(form, sortKey, onApply);

      select.addEventListener('change', handleSortApply);

      form.querySelectorAll('[data-sort-radio]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          select.value = radio.value;
          handleSortApply();
        });
      });
    }

    function mergeCollectionHtml(html, isFullPage) {
      var wasModalOpen = filterModal.open;
      var savedMode = filterModal.mode;
      if (wasModalOpen) {
        restoreFiltersToShell();
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = isFullPage
        ? doc.getElementById('CollectionPage')
        : doc.querySelector('[data-collection-grid]')
          ? doc
          : doc.getElementById('shopify-section-' + getSectionId()) || doc;

      var newPage = isFullPage ? source : null;
      if (isFullPage && newPage) {
        var current = document.getElementById('CollectionPage');
        if (!current) return false;
        current.replaceWith(newPage);
        page = document.getElementById('CollectionPage');
        if (!page) return false;
        filterForm = document.getElementById('CollectionFiltersForm');
        sortForm = document.querySelector('[data-sort-form]');
        if (filterForm) {
          bindFilterForm(filterForm);
        }
        if (sortForm) {
          bindSortForm(sortForm, SORT_KEY, applyFilters);
        }
        var searchEl = document.querySelector('[data-collection-search]');
        if (searchEl) bindCollectionSearch(searchEl, applyCollectionSearch);
        syncSearchFromUrl();
        if (clientSearchActive) {
          var q = new URL(window.location.href).searchParams.get('q') || '';
          if (q) runCollectionSearch(q);
        }
        if (wasModalOpen) {
          filterModal.open = false;
          openFilterModal({ mode: savedMode });
        }
        document.dispatchEvent(new CustomEvent('mootlu:filters-applied'));
        return true;
      }

      var newGrid = source.querySelector('[data-infinite-grid]');
      var grid = document.querySelector('[data-infinite-grid]');
      var newForm = source.getElementById('CollectionFiltersForm');
      var newSortForm = source.querySelector('[data-sort-form]');
      var updated = false;

      if (newGrid && grid) {
        grid.replaceWith(newGrid);
        updated = true;
      }

      replaceInfiniteChrome(source, page);

      if (newForm) {
        var oldForm = document.getElementById('CollectionFiltersForm');
        if (oldForm) {
          oldForm.replaceWith(newForm);
          filterForm = newForm;
          bindFilterForm(filterForm);
          updated = true;
        }
      }

      if (newSortForm) {
        var oldSortForm = document.querySelector('[data-sort-form]');
        if (oldSortForm) {
          oldSortForm.replaceWith(newSortForm);
          sortForm = newSortForm;
          bindSortForm(sortForm, SORT_KEY, applyFilters);
          updated = true;
        }
      }

      syncSearchFromUrl();
      if (clientSearchActive) {
        var qActive = new URL(window.location.href).searchParams.get('q') || '';
        if (qActive) runCollectionSearch(qActive);
      }

      if (updated) {
        if (wasModalOpen) {
          filterModal.open = false;
          openFilterModal({ mode: savedMode });
        }
        document.dispatchEvent(new CustomEvent('mootlu:filters-applied'));
      }
      return updated;
    }

    function bindFilterForm(form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], input[type="radio"]')) {
          if (filterModal.open) return;
          applyFilters();
        }
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
      });
      form.addEventListener(
        'input',
        debounce(function (e) {
          if (e.target.matches('input[type="number"]')) {
            if (filterModal.open) return;
            applyFilters();
          }
        }, 600)
      );
    }

    syncSearchFromUrl();
    var initialQ = new URL(window.location.href).searchParams.get('q');
    if (initialQ && initialQ.trim().length >= 2) {
      runCollectionSearch(initialQ.trim());
    }
  }

  function replaceInfiniteChrome(source, root) {
    if (!root) return;
    var newStatus = source.querySelector('[data-infinite-status]');
    var status = root.querySelector('[data-infinite-status]');
    if (newStatus && status) status.replaceWith(newStatus);

    var newSentinel = source.querySelector('[data-infinite-sentinel]');
    var sentinel = root.querySelector('[data-infinite-sentinel]');
    if (newSentinel && sentinel) sentinel.replaceWith(newSentinel);
  }

  function initCollectionDescription() {
    var wrapper = document.querySelector('[data-collection-description-wrapper]');
    if (!wrapper) return;

    var content = wrapper.querySelector('[data-collection-description-content]');
    var toggleBtn = wrapper.querySelector('[data-collection-description-toggle]');
    if (!content || !toggleBtn) return;

    function checkOverflow() {
      if (content.classList.contains('is-expanded')) return;
      var hasOverflow = content.scrollHeight > (content.clientHeight + 4);
      if (hasOverflow) {
        toggleBtn.removeAttribute('hidden');
        wrapper.classList.add('has-overflow');
      } else {
        toggleBtn.setAttribute('hidden', '');
        wrapper.classList.remove('has-overflow');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkOverflow);
    } else {
      checkOverflow();
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(checkOverflow);
    }
    window.addEventListener('resize', debounce(checkOverflow, 120), { passive: true });

    toggleBtn.addEventListener('click', function () {
      var isExpanded = content.classList.contains('is-expanded');
      if (!isExpanded) {
        var startHeight = content.clientHeight;
        content.classList.add('is-expanded');
        var targetHeight = content.scrollHeight;
        content.style.maxHeight = startHeight + 'px';
        void content.offsetHeight;
        content.style.maxHeight = targetHeight + 'px';
        toggleBtn.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          if (content.classList.contains('is-expanded')) {
            content.style.maxHeight = 'none';
          }
        }, 360);
      } else {
        var startHeight = content.scrollHeight;
        content.style.maxHeight = startHeight + 'px';
        void content.offsetHeight;
        content.classList.remove('is-expanded');
        content.style.maxHeight = '';
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function getSectionId() {
    var collectionPage = document.getElementById('CollectionPage');
    return (
      (collectionPage && collectionPage.dataset.sectionId) ||
      (window.MOOTLU_DATA && window.MOOTLU_DATA.collectionSectionId) ||
      'main'
    );
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }
})();
